import './api'; // Initialize API instance with correct baseURL
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { ThemeProvider, store } from '@inscore/shared';
import useLocale from '@inscore/shared/src/hook/useLocale';
import { ConfigProvider } from 'antd';
import enUS from 'antd/lib/locale/en_US';
import ruRU from 'antd/lib/locale/ru_RU';
import esES from 'antd/lib/locale/es_ES';
import ptBR from 'antd/lib/locale/pt_BR';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import App from './App';
import reportWebVitals from './reportWebVitals';

import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/oswald/400.css';
import '@fontsource/oswald/500.css';
import '@fontsource/oswald/700.css';
import '@fontsource/wdxl-lubrifont-tc/latin-400.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <BrowserRouter>
            <LocaleAwareConfig>
                <ThemeProvider>
                    <App />
                </ThemeProvider>
            </LocaleAwareConfig>
        </BrowserRouter>
    </Provider>
);

function LocaleAwareConfig({ children }) {
    const { locale } = useLocale();

    useEffect(() => {
        try {
            if (locale === 'ru') dayjs.locale('ru');
            else if (locale === 'es') dayjs.locale('es');
            else if (locale === 'pt') dayjs.locale('pt');
            else dayjs.locale('en');
        } catch (e) {
            // Ignore locale setting errors
        }
    }, [locale]);

    const antdLocale =
        locale === 'ru'
            ? ruRU
            : locale === 'es'
              ? esES
              : locale === 'pt'
                ? ptBR
                : enUS;

    return <ConfigProvider locale={antdLocale}>{children}</ConfigProvider>;
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
